import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import {
  NgbModule,
  NgbDropdownModule,
  NgbDatepicker,
  NgbTimepicker,
  NgbTimepickerModule,
  NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { UserAccountMenuComponent } from './partials/user-account-menu/user-account-menu.component';
import { QuickActionsComponent } from './partials/quick-actions/quick-actions.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HttpClientModule } from '@angular/common/http';
import { DynamicNumberViewComponent } from './partials/dynamic-number-view/dynamic-number-view.component';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { SpaceItemComponent } from './partials/space-item/space-item.component';
import { SpaceItemPopoverComponent } from './partials/items-popovers/space-item-popover/space-item-popover.component';
import { UsersGroupComponent } from './partials/users-group/users-group.component';

import { GridListChangerComponent } from './partials/system-lists/grid-list-changer/grid-list-changer.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { systemCurrencyFieldType } from './partials/formly-fields/currency.field.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CreateSpaceModalComponent } from './partials/modals/create-space-modal/create-space-modal.component';
import { CreateSpaceWalletModalComponent } from './partials/modals/create-space-wallet-modal/create-space-wallet-modal.component';
import { ToastrModule } from 'ngx-toastr';
import { TransactionListItemComponent } from './partials/system-lists/transactions-list/transaction-list-item/transaction-list-item.component';
import { TransactionsListComponent } from './partials/system-lists/transactions-list/transactions-list.component';
import { SpaceMiniCardComponent } from './partials/mini-cards/space-mini-card/space-mini-card.component';
import { CreateSpaceTransactionModalComponent } from './partials/modals/create-space-transaction-modal/create-space-transaction-modal.component';

import { systemTransactionCategoryFieldType } from './partials/formly-fields/transaction-category.field.component';
import { WalletItemPopoverComponent } from './partials/items-popovers/wallet-item-popover/wallet-item-popover.component';
import { MoneyFormatPipe } from './pipe/money-format.pipe';
import { UserItemComponent } from './partials/user-item/user-item.component';
import { systemTransactionContactFieldType } from './partials/formly-fields/transaction-contact.field.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { systemTransactionDateTimeFieldType } from './partials/formly-fields/transaction-date-time.field.component';
import { TranslocoModule } from '@jsverse/transloco';
import { HeadFilterSearchComponent } from './partials/head-filter-search/head-filter-search.component';
import { GeniricFilterPipe } from './pipe/generic-filter.pipe';
import { DynamicDropdownComponent } from './partials/dynamic-dropdown/dynamic-dropdown.component';
import { InlineRenameComponent } from './partials/inline-rename/inline-rename.component';
import { InputAutoFocusDirective } from './directives/input-auto-focus.directive';
import { DynamicAiButtonComponent } from './partials/dynamic-ai-button/dynamic-ai-button.component';
import { SwiperModule } from 'swiper/angular';
import { LogoComponent } from './partials/logo/logo.component';
import { RichEditorComponent } from './partials/rich-editor/rich-editor.component';
import { QuillModule } from 'ngx-quill';
import { GlobalFontIconComponent } from './partials/global-font-icon/global-font-icon.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SpecialFilterPipe } from './pipe/special-filter.pipe';
import { AiCtaCardComponent } from './partials/ai/ai-cta-card/ai-cta-card.component';
import { AiCursorComponent } from './partials/ai/ai-cursor/ai-cursor.component';
import { AiIdeaGeneratorComponent } from './partials/ai/ai-idea-generator/ai-idea-generator.component';
import { AiCategorySelectComponent } from './partials/ai/ai-idea-generator/ai-category-select/ai-category-select.component';
import { AiThinkingLoaderComponent } from './partials/ai/ai-thinking-loader/ai-thinking-loader.component';
import { AiExtraInformationInputComponent } from './partials/ai/ai-idea-generator/ai-extra-information-input/ai-extra-information-input.component';
import { UserAvatarViewComponent } from './layout/user-layout/header/top-bar/user-avatar-view/user-avatar-view.component';



const systemPipes = [
  GeniricFilterPipe,
  MoneyFormatPipe,
  SpecialFilterPipe
]


const globalAiComponents = [
  AiCtaCardComponent,
  AiCursorComponent,
  AiIdeaGeneratorComponent,
  AiCategorySelectComponent,
  AiExtraInformationInputComponent,
  AiThinkingLoaderComponent,
]
@NgModule({
  declarations: [
    
    // User Components
    UserAccountMenuComponent,
    QuickActionsComponent,
    UserAvatarViewComponent,

    UsersGroupComponent,
    // Global Components
    DynamicNumberViewComponent,
    SpaceItemComponent,
    HeadFilterSearchComponent,
    DynamicDropdownComponent,
    DynamicAiButtonComponent,
    InlineRenameComponent,
    LogoComponent,
    RichEditorComponent,
    GlobalFontIconComponent,
    ...globalAiComponents,

    // Directives
    InputAutoFocusDirective,

    // Popovers
    SpaceItemPopoverComponent,
    WalletItemPopoverComponent,

    // Modals
    CreateSpaceModalComponent,
    CreateSpaceWalletModalComponent,
    CreateSpaceTransactionModalComponent,

    // System Lists
    GridListChangerComponent,
    TransactionListItemComponent,
    TransactionsListComponent,

    // Mini Cards
    SpaceMiniCardComponent,
    UserItemComponent,
    // Fields
    systemCurrencyFieldType,
    systemTransactionCategoryFieldType,
    systemTransactionContactFieldType,
    systemTransactionDateTimeFieldType,

    // Pipes
    ...systemPipes,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,


    
    

    QuillModule.forRoot(),
    // Third-parties
    NgbModule,
    NgbDropdownModule,
    AngularSvgIconModule.forRoot(),
    NgxTippyModule,
    NgxSkeletonModule,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    FormlyModule.forRoot({
      types: [
        { name: 'system-currency', component: systemCurrencyFieldType },
        {
          name: 'system-transaction-category',
          component: systemTransactionCategoryFieldType,
        },
        {
          name: 'system-transaction-contact',
          component: systemTransactionContactFieldType,
        },
        {
          name: 'system-transaction-date-time',
          component: systemTransactionDateTimeFieldType,
        },
      ],
    }),

    FormlyBootstrapModule,
    NgSelectModule,
    NgbDatepickerModule,
    NgbTimepickerModule,

    SwiperModule,

    FlatpickrModule.forRoot(),

    ToastrModule.forRoot({
      preventDuplicates: true,
      positionClass: 'toast-bottom-right',
    }),

    TranslocoModule,
  ],
  exports: [
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgbDropdownModule,
    NgxTippyModule,
    NgxSkeletonModule,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyBootstrapModule,
    NgSelectModule,
    ToastrModule,
    FlatpickrModule,
    SwiperModule,
    QuillModule,

    // Components
    SpaceItemComponent,

    // Popovers
    SpaceItemPopoverComponent,
    WalletItemPopoverComponent,

    // Global Components
    DynamicNumberViewComponent,
    UsersGroupComponent,
    HeadFilterSearchComponent,
    DynamicDropdownComponent,
    DynamicAiButtonComponent,
    InlineRenameComponent,
    LogoComponent,
    RichEditorComponent,
    GlobalFontIconComponent,
    ...globalAiComponents,


    // Directives
    InputAutoFocusDirective,
    
    // Modals
    CreateSpaceModalComponent,
    CreateSpaceWalletModalComponent,
    CreateSpaceTransactionModalComponent,

    // User Components
    UserAccountMenuComponent,
    QuickActionsComponent,
    AngularSvgIconModule,
    HttpClientModule,
    UserAvatarViewComponent,

    // System Lists
    GridListChangerComponent,
    TransactionListItemComponent,
    TransactionsListComponent,

    // Mini Cards
    SpaceMiniCardComponent,
    UserItemComponent,

    // Pipes
    ...systemPipes,

    TranslocoModule,
  ],
})
export class SharedModule {}
